import { NumberFormatOptions } from 'vue-i18n'
import { CaseType } from '../../Case/interfaces/case'

export enum RuleOrderBy {
  ID = 'ID',
  POLICY_NAME = 'POLICY_NAME',
  EFFECTIVE_DATE = 'EFFECTIVE_DATE',
  EXPIRATION_DATE = 'EXPIRATION_DATE',
  POLICY_NUMBER = 'POLICY_NUMBER',
  POLICY_STATUS = 'POLICY_STATUS',
}

export enum RelationCondition {
  CONTAINS = 'CONTAINS',
  WITHOUT = 'WITHOUT',
}

export interface PolicyReportRule {
  id: number
  name: string
  displayColumns: string[]
  orderBy: RuleOrderBy
  asc: boolean
  bindDate: number
  effectiveDate: number
  expirationDate: NumberFormatOptions
  cancelDate: number
  gaCondition: RelationCondition
  gaConditionValue: number[]
  carrierCondition: RelationCondition
  carrierConditionValue: number[]
  sourceCondition: RelationCondition
  sourceConditionValue: number[]
  insuranceProductCondition: RelationCondition
  insuranceProductConditionValue: number[]
  recordTypeCondition: RelationCondition
  recordTypeConditionValue: number[]
  policyTypeCondition: RelationCondition
  policyTypeConditionValue: CaseType[]
  nonRenew: boolean
  createdAt: number
  updatedAt: number
}
